(() => {
  const mobile = matchMedia('(max-width:749px)');
  function install(media) {
    const card = media.closest('.card-wrapper');
    const images = media.querySelectorAll(':scope > img');
    if (!card || images.length < 2 || media.dataset.cvCardReady) return;
    media.dataset.cvCardReady = 'true';
    card.classList.add('cv-card-swipe-ready');
    let gesture = null, suppressClick = false, pending = 0;
    function show(index) {
      const request = ++pending;
      const image = images[index];
      const apply = () => {
        if (pending === request && image.naturalWidth > 0) media.dataset.cvCardImage = String(index);
      };
      if (image.complete) apply();
      else { image.addEventListener('load',apply,{once:true}); image.loading = 'eager'; }
    }
    card.addEventListener('touchstart',event => {
      gesture = null;
      suppressClick = false;
      if (!mobile.matches || event.touches.length !== 1 || event.target.closest('button,input,select,textarea')) return;
      const touch = event.touches[0], box = media.getBoundingClientRect();
      if (touch.clientX < box.left || touch.clientX > box.right || touch.clientY < box.top || touch.clientY > box.bottom) return;
      gesture = {id:touch.identifier,x:touch.clientX,y:touch.clientY,dx:0,locked:false};
    },{passive:true});
    card.addEventListener('touchmove',event => {
      if (!gesture) return;
      if (event.touches.length !== 1) { gesture = null; return; }
      const touch = event.touches[0];
      if (touch.identifier !== gesture.id) return;
      const dx = touch.clientX - gesture.x, dy = touch.clientY - gesture.y;
      if (!gesture.locked) {
        if (Math.max(Math.abs(dx),Math.abs(dy)) < 8) return;
        if (Math.abs(dy) >= Math.abs(dx)) { gesture = null; return; }
        gesture.locked = true;
      }
      gesture.dx = dx;
      suppressClick = true;
      if (event.cancelable) event.preventDefault();
    },{passive:false});
    card.addEventListener('touchend',event => {
      if (!gesture) return;
      const saved = gesture;
      gesture = null;
      if (!Array.from(event.changedTouches).some(touch => touch.identifier === saved.id)) return;
      const threshold = Math.min(48,Math.max(24,media.getBoundingClientRect().width * .12));
      if (saved.locked && Math.abs(saved.dx) >= threshold) show(saved.dx < 0 ? 1 : 0);
    },{passive:true});
    card.addEventListener('touchcancel',() => { gesture = null; },{passive:true});
    card.addEventListener('click',event => {
      if (!suppressClick || event.detail === 0) return;
      suppressClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    },true);
  }
  function scan(root) {
    if (root.matches?.('[data-cv-card-swipe]')) install(root);
    root.querySelectorAll?.('[data-cv-card-swipe]').forEach(install);
  }
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event => scan(event.target));
})();
